import React from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import {
  Box,
  Button,
  Container,
} from '@mui/material'
import {
  ArrowBack,
} from '@mui/icons-material'

import AssessmentTaking from '../components/AssessmentTaking'

const AssessmentPage: React.FC = () => {
  const { assessmentId } = useParams<{ assessmentId: string }>()
  const navigate = useNavigate()

  if (!assessmentId) {
    return (
      <Container maxWidth="md" sx={{ mt: 4 }}>
        <Box>
          <Button
            startIcon={<ArrowBack />}
            onClick={() => navigate('/dashboard')}
            sx={{ mb: 2 }}
          >
            Back to Dashboard
          </Button>
        </Box>
      </Container>
    )
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 3 }}>
        <Button
          startIcon={<ArrowBack />}
          onClick={() => navigate('/dashboard')}
          variant="outlined"
        >
          Back to Dashboard
        </Button>
      </Box>
      
      <AssessmentTaking
        assessmentId={assessmentId}
        embedded={false}
        onComplete={() => {
          // After completing standalone assessment, go back to dashboard
          setTimeout(() => {
            navigate('/dashboard')
          }, 3000)
        }}
      />
    </Container>
  )
}

export default AssessmentPage
